import styled from 'styled-components';

export const Image = styled.img`
  max-width: 800px;
  width: 100%;
`;

export const Img = styled.img`
  max-width: 100%;
`;

export const SourceText = styled.p`
  text-align: right;
  margin-right: 8px;
  margin-top: 0;
`;
